export const INVALID_CHARS_RE = /[^A-Za-z\d¡!#$%&()*+,\-./:;<=>¿?@[\]\\^_{|}~]/gu;

export const getInvalidCharsMessage = (value: string): string | null => {
  const invalidChars = value.match(INVALID_CHARS_RE) || [];
  if (!invalidChars.length) return null;
  const uniqueInvalidChars = Array.from(new Set(invalidChars)).join('');
  return `No se permiten estos caracteres: ${uniqueInvalidChars}`;
};
